import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common/common.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { RolesAndPermissionService } from '../../services/roles-and-permission/roles-and-permission.service';
import { lastValueFrom, filter } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { MenuService } from '../../services/menus/menu.service';
import { SidebarService } from '../../services/sidebar/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  public menulist!: any[];
  parentMenulist: any[] = [];
  menuItem!: any[];
  parentMenuID!: number;
  menubyID: any[] = [];
  isCollapsed: boolean = false;
  isSubMenuCollapsed: boolean = true;
  user!: any;
  expandedMenu: number | null = null;
  expandedMenus: Set<number> = new Set();
  groupedMasters: any[] = [];
  isSidebarDisabled: boolean = false;
  expandedGroup: string | null = null;
  searchTerm: string = '';
  filteredParentMenuList: any[] = [];


  constructor(
    private readonly common: CommonService,
    private readonly router: Router,
    private readonly permissionService: RolesAndPermissionService,
    private readonly auth: AuthService,
    private readonly menuService: MenuService,
    private readonly route: ActivatedRoute,
    private readonly sidebarService: SidebarService,
  ) {
    this.getRole();
  }
  ngOnInit(): void {

    if (this.user.role == 1 || this.user.role == 2) {
      this.parentMenuID = 1;
    } else if (this.user.role == 4 || 3) {
      this.parentMenuID = 5;
    }
    this.getPermission();

    this.getMenuById(this.parentMenuID);
    this.getAllMenus();

    this.sidebarService.sidebarDisabled$.subscribe((value) => {
      this.isSidebarDisabled = value;
    });

    const lowProfilePercent = this.route.snapshot.queryParamMap.get('lowprofilepercent');
    this.sidebarService.setSidebarDisabled(lowProfilePercent === 'true');

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.syncMenuWithRoute();
    });

    this.syncMenuWithRoute();
  }

  private syncMenuWithRoute() {
    const menus = JSON.parse(localStorage.getItem('menus') || '[]');
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const matchedMenu = menus.find((menu: any) => menu.link === currentPath);

    if (matchedMenu) {
      this.setMenuId(matchedMenu.id);
      if (matchedMenu.link === '/app/reports/all-reports') {
        this.expandedMenu = matchedMenu.id;
      }
    }
  }
  toggleGroup(groupName: string): void {
    // If same group clicked again → collapse it
    this.expandedGroup = this.expandedGroup === groupName ? null : groupName;
  }

  toggleSidebar(status: boolean) {
    this.isCollapsed = status;
  }

  buildMastersGroups() {
    const mastersMenus = this.menulist.filter(m => m.parentID === 16); // Masters ID

    const groupingRules: any = {
      'Admin Masters': [
        'Leave Type', 'Loan Types', 'Benefits Type', 'Pay Components', 'Currency Exchange',
        'Holiday Master', 'Work Shift', 'Calendar', 'Sponsor', 'Policy Master',
        'Message Template', 'Leave Combination', 'Leave Warning Messages', 'User Group',
        'Classification', 'Alert Settings', 'Insurance Master', 'Document Master', 'User',
        'Reason', 'Roles and Permissions'
      ],
      'Personnel Masters': [
        'Grade Master', 'Language', 'Designation', 'Awards and Recognition', 'Announcement',
        'Widget', 'Job Categories', 'Asset Type', 'Asset Inventory', 'Forms & Letters', 'Action Master', 'Educational Discipline', 'Educational level', 'Events', 'Airport', 'Travel Type', 'Dependents', 'Project', 'Competency', 'Expense Type'
      ],
      'Policy Grouping': ['Leave Policy Group', 'Loan Type Group', 'Benefits Type Group', 'Pay Policy Group', 'Expense Policy', 'Project Policy'],
      'Payroll': ['Pay Cycle', 'Formula', 'Credit Debit', 'Cost Center Mapping'],
      'T & A': ['OT Master', 'Break', 'Shift Roaster'],
      'ESS / WF': ['Workflow', 'Workflow Proxy']
    };

    const grouped: any[] = [];

    Object.keys(groupingRules).forEach(groupName => {
      grouped.push({
        groupName,
        menus: mastersMenus.filter(m => groupingRules[groupName].includes(m.name))
      });
    });

    this.groupedMasters = grouped;
  }

  toggleSubMenuSidebar() {
    this.isSubMenuCollapsed = !this.isSubMenuCollapsed;
  }
  toggleSubMenu(item: any) {
    if (item.link === '/app/reports/all-reports') {
      this.expandedMenu = item.id;
      this.expandedMenus.clear();
      this.router.navigate([item.link]);
      return;
    }
    // If there's a search, don't allow toggling - keep all matching menus expanded
    if (this.searchTerm.trim()) {
      return;
    }
    this.expandedMenu = this.expandedMenu === item.id ? null : item.id;
    this.expandedMenus.clear();
  }

  onMouseEnter(type: any) {
    this.toggleSidebar(type);
  }

  async getAllMenus() {
    const allMenus = await lastValueFrom(this.menuService.getAllMenus());
    this.auth.allMenuList = allMenus.data;
  }

  // onMouseLeave(){
  //   this.toggleSidebar(false);
  // }

  getMenuById(id: number): void {
    this.menubyID = [];
    const term = this.searchTerm.toLowerCase().trim();

    this.menulist &&
      this.menulist.length > 0 &&
      this.menulist.forEach((menu) => {
        if (menu.parentID === id && menu.can_view) {
          // Only show submenu if no search term or submenu name matches the search term
          if (!term || menu.name.toLowerCase().includes(term)) {
            this.menubyID.push(menu);
          }
        }
      });

    if (this.menubyID.length > 0) {
      this.menubyID = this.menubyID.sort((a: any, b: any) => a.order - b.order);
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.filterMenus();
  }

  filterMenus() {
    const term = this.searchTerm.toLowerCase().trim();
    if (!term) {
      this.filteredParentMenuList = [...this.parentMenulist];
      this.expandedMenu = null;
      this.expandedMenus.clear();
      this.syncMenuWithRoute();
      return;
    }

    // Find all matching menus (parents or children)
    const matchingMenus = this.menulist.filter(m =>
      m.name.toLowerCase().includes(term) && m.can_view
    );

    // Get all parent IDs of matching menus
    const parentIds = new Set<number>();
    matchingMenus.forEach(m => {
      if (!m.parentID || m.parentID === m.id) {
        parentIds.add(m.id);
      } else {
        parentIds.add(m.parentID);
      }
    });

    // Filter parentMenulist to only those whose ID is in parentIds
    this.filteredParentMenuList = this.parentMenulist.filter(p => parentIds.has(p.id));

    // Expand all matching parent menus
    this.expandedMenus.clear();
    if (this.filteredParentMenuList.length > 0) {
      this.filteredParentMenuList.forEach(menu => {
        this.expandedMenus.add(menu.id);
      });
    }
  }

  isMenuExpanded(menuId: number): boolean {
    // If there's a search term, check the expandedMenus set
    if (this.searchTerm.trim()) {
      return this.expandedMenus.has(menuId);
    }
    // Otherwise, check the single expandedMenu
    return this.expandedMenu === menuId;
  }

  setSubMenus(id: number) {
    this.parentMenuID = id;
    this.getMenuById(this.parentMenuID);
    return this.menubyID;
  }

  setSubMenu(id: number) {
    this.parentMenuID = id;
    this.getMenuById(this.parentMenuID);
  }

  getRole() {
    this.user = this.common.getRole();
    this.user = JSON.parse(this.user);
  }

  isMenuVisible(submenu: any) {
    if (submenu.role?.includes(this.user.role)) {
      return true;
    } else {
      return false;
    }
  }

  async getPermission() {
    const response = await lastValueFrom(
      this.permissionService.getPermission(this.user.group_id || 0)
    );

    // this.menulist = JSON.parse(localStorage.getItem('menus') || '[]');
    this.menulist = response?.data || [];
    localStorage.setItem('menus', JSON.stringify(this.menulist));
    this.auth.menuList = this.menulist;
    this.menulist = this.menulist.sort((a, b) => a.order - b.order);
    this.menulist.forEach((menu) => {
      if (!menu?.parentID || menu?.parentID == menu?.id) {
        this.parentMenulist.push(menu);
      }
    });
    this.filteredParentMenuList = [...this.parentMenulist];
    // Do not automatically set sub menu to first parent if we already have a selected menu from refresh
    if (!this.auth.selectedMenuID) {
      this.setSubMenu(this.parentMenulist[0]?.id);
    } else {
      // If we have a selectedMenuID, we might need to find its parent to expand the right section
      const activeMenu = this.menulist.find(m => m.id === this.auth.selectedMenuID);
      if (activeMenu && activeMenu.parentID) {
        this.setSubMenu(activeMenu.parentID);
        this.expandedMenu = activeMenu.id;
      }
    }
    // this.router.navigate([this.menubyID[0]?.link]);

    this.syncMenuWithRoute();
    this.buildMastersGroups();
  }

  setMenuId(id: number) {
    this.auth.selectedMenuID = id;
  }
}
